export default __webpack_public_path__ + "static/media/it-82.d56af330.svg";